import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import crmService from "../../crmConfig.json";
import { crmAxios } from "../../app/crmApi";
import { errorToast, successToast } from "../../helpers/toaster";

const initialState = {
  profile: null,
  dashboard: null,
  loading: false,
};

export const fetchAgentProfileAsync = createAsyncThunk(
  "crmAgent/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const res = await crmAxios.get(crmService.agentProfile);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const updateAgentProfileAsync = createAsyncThunk(
  "crmAgent/updateProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await crmAxios.put(crmService.agentProfile, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchAgentDashboardAsync = createAsyncThunk(
  "crmAgent/fetchDashboard",
  async (_, { rejectWithValue }) => {
    try {
      const res = await crmAxios.get(crmService.agentDashboard);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

const crmAgentSlice = createSlice({
  name: "crmAgent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgentProfileAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAgentProfileAsync.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.success) state.profile = payload.data;
      })
      .addCase(fetchAgentProfileAsync.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateAgentProfileAsync.fulfilled, (state, { payload }) => {
        if (payload?.success) {
          state.profile = payload.data;
          successToast(payload.message);
        } else {
          errorToast(payload?.message || "Update failed");
        }
      })
      .addCase(updateAgentProfileAsync.rejected, (state, { payload }) => {
        errorToast(payload?.message || "Update failed");
      })
      .addCase(fetchAgentDashboardAsync.fulfilled, (state, { payload }) => {
        if (payload?.success) state.dashboard = payload.data;
      });
  },
});

export const selectAgentProfile = (state) => state.crmAgent.profile;
export const selectAgentDashboard = (state) => state.crmAgent.dashboard;
export const selectAgentLoading = (state) => state.crmAgent.loading;

export default crmAgentSlice.reducer;
